var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEscalate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path11077",
    d: "m 13.984375,2.6517334 q 0,0.7751465 -0.511597,5.2089844 -0.511596,4.4338382 -0.89917,8.5731202 H 11.36438 Q 11.023315,12.294556 10.511719,7.8607178 10.015625,3.4268799 10.015625,2.6517334 q 0,-0.883667 0.558105,-1.4882813 Q 11.131836,0.55883789 12,0.55883789 q 0.868164,0 1.42627,0.60461421 0.558105,0.5891114 0.558105,1.4882813 z m 0.139526,18.6965336 q 0,0.868164 -0.63562,1.488281 Q 12.868164,23.441162 12,23.441162 q -0.868164,0 -1.503784,-0.604614 -0.6201174,-0.620117 -0.6201174,-1.488281 0,-0.868164 0.6201174,-1.488282 0.63562,-0.63562 1.503784,-0.63562 0.868164,0 1.488281,0.63562 0.63562,0.620118 0.63562,1.488282 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalate);
export default __webpack_public_path__ + "static/media/Escalate.aef9c15406e416c4a2f8aa6210478cbd.svg";
export { ForwardRef as ReactComponent };